import { Injectable } from '@angular/core';
import { CartService } from '../core/cart.service';
import { MyEventService } from '../core/event.service';
import { AuthResource, IAuth } from './auth.resource.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private currentAuth: IAuth;

  constructor(
    private resource: AuthResource,
    private myEventService: MyEventService,
    private cartService: CartService,
    // private translateService: TranslateService,
  ) {
    this.getAuth();
  }

  private getAuth() {
    try {
      this.currentAuth = JSON.parse(localStorage.getItem('auth'));
      this.myEventService.broadcast('auth.created');
    } catch (error) {

    }
  }

  private saveAuth(auth) {
    this.currentAuth = auth;
    try {
      localStorage.setItem('auth', JSON.stringify(auth));
    } catch (error) { }
  }

  private resetAuth() {
    this.currentAuth = undefined;
    try {
      this.cartService.resetCart();
      localStorage.clear();
    } catch (error) { }
  }

  login(credentials: { username: string, password: string }): Promise<IAuth> {
    return new Promise((resolve, reject) => {
      this.resource.login(credentials).then((auth) => {
        this.saveAuth(auth);
        this.cartService.resetCart();

        this.myEventService.broadcast('auth.created', auth);
        resolve(auth);
      }, (err) => {
        this.resetAuth();
        this.myEventService.broadcast('auth.revoked');
        reject(err);
      });
    });
  }

  logout() {
    this.resetAuth();
    this.myEventService.broadcast('auth.revoked');
    return new Promise((resolve) => {
      this.resource.logout().finally(() => {
        resolve(undefined);
      });
      if (window.location.pathname !== '/login') {
        window.location.replace('/login');
      }
    });
  }

  isAuthenticated(): boolean {
    return !!this.currentAuth && !!this.currentAuth.accesstoken && !!this.currentAuth.user;
  }

  isNewAccount(): boolean {
    return !!this.currentAuth && !!this.currentAuth.newAccount;
  }

  refreshToken(): Promise<IAuth> {
    return new Promise((resolve, reject) => {
      this.resource.refresh().then((auth) => {
        this.saveAuth(auth);

        this.myEventService.broadcast('auth.created', auth);
        resolve(auth);
      }, () => {
        this.resetAuth();
        this.myEventService.broadcast('auth.revoked');
        reject();
      });
    });
  }

  refreshSession() {
    let promise;
    promise = this.resource.check();

    promise.then((auth) => {
      this.saveAuth(auth);
      this.myEventService.broadcast('auth.created', auth);
    }, () => {
      this.resetAuth();
      this.myEventService.broadcast('auth.revoked');
    });
    return promise;
  }

  getAccessToken() {
    if (this.isAuthenticated() && this.currentAuth) {
      return this.currentAuth.accesstoken;
    }
    return '';
  }

  getRefreshToken() {
    if (this.isAuthenticated() && this.currentAuth) {
      return this.currentAuth.refreshtoken;
    }
    return '';
  }

  getUser() {
    return this.currentAuth.user;
  }

  getInviteData(hash) {
    return this.resource.getInviteData({ hash });
  }

  resendInvite(hash) {
    return this.resource.resendInvite({ hash })
  }

  requestResetPassword(email) {
    return this.resource.requestResetPassword({ email })
  }

  getResetHash(email, code) {
    return this.resource.getResetHash({ email, code });
  }

  resetPassword(obj) {
    return this.resource.resetPassword(obj)
  }

  getGreeting() {
    if (this.isAuthenticated()) {
      if (this.currentAuth.user) {
        const user = this.currentAuth.user;
        let greetingArr = [user.firstname || 'mr. / mevr.', user.lastname];
        greetingArr = greetingArr.filter(s => s);
        if (greetingArr.length > 1) {
          return greetingArr.join(' ');
        }
        return user.email;
      }
      return 'Gebruiker';
    }
  }

  getLanguage() {
    try {
      return this.currentAuth.user.language || 'en';
    } catch (error) { }
  }
}
